// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTop_button__EY9Gf","show":"ScrollToTop_show__8V6su","arrow":"ScrollToTop_arrow__BhOsU"};